import { paginationStyle,
  toggleButtonStyle,
  searchboxStyle,
  tableStyle,
  linkStyle,
  statusStyle,
  containerBudgetStyle,
  sharedBudgetGridWrapper,
  selectElementStyle,
  uurlTestToolStyle,
  alertStyle } from '@bingads-webui-campaign-react/common-styles';
import { getCollapsiblePanelStyles, getStepStyles } from '../../shared/styles';

export const getStyles = (components, theme) => ({
  collapsiblePanel: {
    ...getCollapsiblePanelStyles(components, theme),
    '& .jumbo-card-control-all-btn-stack': {
      width: '20%',
    },
    '& .panel-heading': {
      padding: 0,
      borderBottom: 'none',
      marginBottom: 18,
      display: 'flex',

      '& .panel-title': {
        fontSize: 18,
        width: '80%',
        '& > a': {
          color: theme.palette.themePrimary,
          padding: 0,
          '&:hover, &:active': {
            color: theme.palette.themeDarker,
            textDecoration: 'none',
            backgroundColor: 'unset',
          },
        },

        '& > a:after': {
          transform: 'rotate(180deg)',
        },

        '& > a.collapsed:after': {
          transform: 'rotate(90deg)',
        },
      },
    },
  },
  campaignEditSettingsStep: {
    ...getStepStyles(),
    ...searchboxStyle,
    ...toggleButtonStyle,
    ...linkStyle,
    ...containerBudgetStyle(theme),
    ...sharedBudgetGridWrapper(theme),
    ...tableStyle(theme),
    ...selectElementStyle(theme),
    ...alertStyle(theme),
    ...statusStyle(theme),
    ...paginationStyle(theme),
    ...uurlTestToolStyle(theme),
    '& .displayNone': {
      display: 'none',
    },
    '& ol, ul': {
      listStyle: 'none',
      paddingLeft: 0,
    },
    '& .basic-campaign-section': {
      '& .jumbo-card-control-all-btn-stack': {
        padding: '9px 0',
      },
    },

    '& .collapse-panel.disclaimer': {
      '& .collapse-content': {
        display: 'flex',
        flexDirection: 'column',
      },
    },
    '& .collapse-fixed-panel.website': {
      '& .collapse-title-bar': {
        paddingBottom: '5px',
      },
    },
    '& .section-title': {
      marginTop: '28px',
      marginBottom: '8px',
    },
    '& .section-description': {
      marginBottom: '16px',
    },
  },
});
